module.exports = __webpack_public_path__ + "media/images/frontend/map-86445bd99fe824f4f4a367e7ee920e9f.svg";